// This file is auto-generated by scripts/generate-version.js
// Do not edit manually

export const VERSION = '1.1.8.5ac65627';
export const SEMVER = '1.1.8';
export const GIT_SHA = '5ac65627';

export default VERSION;
